module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/banner-556825967fcf876b31681fc675f63f36.png";